/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file getExecutionIds selector
 * @author Roland Scott
 * @module react-async-hook\api\selectors\get-execution-ids
 */

import { IAsyncState } from "../../types";
import { getExecutionIds as internalGetExecutionIds } from "../../internal/state/selectors";

/**
 * Get the list of execution ids from the state, sorted oldest to newest.
 * @param state The async state
 */
export function getExecutionIds<TReturn = any>(state: IAsyncState<TReturn>): number[] {
	return internalGetExecutionIds(state as any);
}
